import { createRoute } from '@tanstack/react-router'
import { authenticatedRoute } from '../_authenticated'
import { AppearanceSettings } from '@/pages/settings'

export const appearanceSettingsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/settings/appearance',
  component: AppearanceSettings,
})
